module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_11"
    }
  }, [_c('span', [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e82011"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c4_r1#d6e2",
      "id": "d7e2"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Part 1")]), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("The Idea and the Legacy ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph",
    attrs: {
      "id": "d7e82811"
    }
  }, [_c('span', [_c('i', [_vm._v("Laughter is one of the most frequent symptoms of madness.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extbd",
    attrs: {
      "id": "d7e83311"
    }
  }, [_c('span', [_vm._v("—C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARLES ")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUDELAIRE ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-232e2070","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lind_9781595554796_epub_c6_r1.vue
// module id = 72
// module chunks = 0